__webpack_require__.p = "https://parcelhub.ae/accountingmasters/exchanges/";